var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGenerateSpeech = function SvgGenerateSpeech(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.25,
    d: "M0 12.488V26c0 10 4 14 14 14h12c10 0 14-4 14-14V14C40 4 36 0 26 0H14C4 0 0 4 0 14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.75 9C9.748 9 7 11.748 7 15.75v6.901c0 3.577 2.194 6.152 5.517 6.659l.233.031v1.51c0 1.665 1.798 2.674 3.206 1.868l.131-.081 4.868-3.237h4.297c3.917 0 6.633-2.632 6.747-6.497l.004-.254v-6.9c0-4.003-2.748-6.75-6.75-6.75H13.75zm0 2h11.501c2.898 0 4.75 1.852 4.75 4.75v6.901c0 2.898-1.852 4.75-4.75 4.75h-4.6c-.197 0-.39.058-.554.167l-5.119 3.405a.147.147 0 01-.228-.123V28.4a1 1 0 00-1-1C10.852 27.4 9 25.548 9 22.65v-6.9C9 12.852 10.852 11 13.75 11zm-.095 4.914a1 1 0 00-.037 1.999l11.35.21a1 1 0 00.037-1.999l-11.35-.21zm-.022 4.044a1 1 0 10-.053 1.999l7.945.21a1 1 0 10.053-1.999l-7.945-.21z"
  })));
};
export default SvgGenerateSpeech;